import { IconLibMetaData } from "./types";
import { IconThemeType } from "../icon/types";
import { iconsListData as webIconNames } from "../../themes/web/assets/icons/icons-list/iconsListData";
import { iconsListData as responsiveIconNames } from "../../themes/responsive/assets/icons/icons-list/iconsListData";

export const AVAILABLE_ICONS: Record<IconThemeType, IconLibMetaData[]> = {
    // @ts-expect-error Check for typing
    web: webIconNames,
    // @ts-expect-error Check for typing
    responsive: responsiveIconNames
};
